import sharedStyles from '@muiscss/sharedStyles.module.scss'
import clsx from 'clsx'
import { forwardRef } from 'react'
import styles from './styles.module.scss'
import { IRadioProps } from './types'

const getControlModeProps = (id: string, value?: string, defaultValue?: string) => {
  if (value !== undefined) {
    return { checked: value === id }
  }
  return { defaultChecked: defaultValue === id }
}

// TO DO CHECKBOXES AND RADIOS SHARE ALL CODE EXCEPT THE LABEL:BEFORE
const Radio = forwardRef<HTMLFieldSetElement, IRadioProps>(
  (
    {
      direction = 'column',
      disabled = false,
      hasBorder,
      hasError,
      id,
      label,
      name,
      options,
      required,
      size = 'md',
      slots,
      style,
      value,
      defaultValue,
      ...props
    },
    ref,
  ) => {
    return (
      <fieldset
        className={clsx('mui-radio-fieldset', styles.wrap, styles[size], styles[direction], {
          [sharedStyles.disabled]: disabled,
        })}
        data-testid="test-radios"
        id={id}
        role="group"
        style={style}
        ref={ref}
      >
        {label && (
          <legend
            className={clsx('mui-input-label', 'body-16-regular', styles.title)}
            data-testid="mui-label"
          >
            {label}
            {required && '*'}
          </legend>
        )}
        {slots?.before && slots.before}
        {options.map((option) => (
          <span className={clsx(styles.option, styles[size])} key={`${id}_${option.id}`}>
            <input
              className={clsx('mui-radio', styles.radio, styles[size])}
              data-testid={`mui-radio-${option.id}`}
              disabled={option.disabled}
              id={option.id}
              name={name || `${id}-radio`}
              required={required}
              type="radio"
              {...getControlModeProps(option.id, value, defaultValue)}
              {...props}
            />
            {option?.slots?.before && option.slots.before}
            <label
              className={clsx(styles.label, styles[size], {
                [sharedStyles.disabled]: option.disabled,
                [styles.error]: hasError,
                [styles.border]: hasBorder,
              })}
              data-testid={`test-radios-label-${option.id}`}
              htmlFor={option.id}
            >
              <span className={styles.text} data-style="radio-content">
                {option.label}
              </span>
            </label>
            {option?.slots?.after && <span>{option.slots.after}</span>}
          </span>
        ))}
        {slots?.after && slots.after}
      </fieldset>
    )
  },
)

export default Radio
